import { useBreakpointValueGS } from 'hooks/useBreakpointValueGS';
import React from 'react';
import { StyleSheet, Text, View } from 'react-native';
import theme from 'theme';
import { formatTimeWithHSeparator, getWeekdayAbbreviation, isToday } from 'utils/date';
import { calcSizeForDevice } from 'utils/index';
import { Platform } from 'utils/platform';

type EventDateTagProps = {
  startDate: Date;
};

export const EventDateTag: React.FC<EventDateTagProps> = ({ startDate }) => {
  const isAndroidTV = Platform.isAndroidTV;
  const tagBorderBottomRightRadius = isAndroidTV ? 8 : 16;

  const eventTagHeight = useBreakpointValueGS({
    base: isAndroidTV ? calcSizeForDevice(51) : 24,
    lg: calcSizeForDevice(40, 51),
  });

  const eventDayTagWidth = useBreakpointValueGS({
    base: isAndroidTV ? calcSizeForDevice(110) : 50,
    lg: calcSizeForDevice(95, 120),
  });

  const eventTimeTagWidth = useBreakpointValueGS({
    base: isAndroidTV ? calcSizeForDevice(125) : 60,
    lg: calcSizeForDevice(100, 125),
  });

  const eventTagTextSize = useBreakpointValueGS({
    base: isAndroidTV ? calcSizeForDevice(32) : 14,
    lg: calcSizeForDevice(24, 32),
  });

  if (!startDate || isNaN(startDate.getTime())) return null;

  return (
    <View style={[styles.container, { borderBottomRightRadius: tagBorderBottomRightRadius }]}>
      <View
        style={[
          styles.dayTag,
          {
            width: eventDayTagWidth,
            height: eventTagHeight,
          },
        ]}>
        <Text style={[styles.dayText, { fontSize: eventTagTextSize }]}>
          {(isToday(startDate) ? 'Hoje' : getWeekdayAbbreviation(startDate.getDay())).toUpperCase()}
        </Text>
      </View>
      <View
        style={[
          styles.timeTag,
          {
            width: eventTimeTagWidth,
            height: eventTagHeight,
            borderBottomRightRadius: tagBorderBottomRightRadius,
          },
        ]}>
        <Text style={[styles.timeText, { fontSize: eventTagTextSize }]}>
          {formatTimeWithHSeparator(startDate)}
        </Text>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    position: 'absolute',
    top: 0,
    left: 0,
    flexDirection: 'row',
    shadowColor: 'rgb(0, 0, 0)',
    shadowOpacity: 0.3,
    shadowRadius: 25,
  },
  dayTag: {
    backgroundColor: theme.colors.secondary[500],
    alignItems: 'center',
    justifyContent: 'center',
  },
  dayText: {
    color: theme.colors.base.darkBlue,
    fontWeight: '800', // $extrabold
  },
  timeTag: {
    backgroundColor: '#181A20',
    alignItems: 'center',
    justifyContent: 'center',
  },
  timeText: {
    color: theme.colors.base.white,
    fontWeight: '800', // $extrabold
  },
});
